module.exports = __webpack_public_path__ + "img/prize.2643b19c.svg";